import { TEAM_COLORS, DEFAULT_TEAM_COLOR } from '../constants';
import './games-view.css';

function statusLabel(status) {
  if (status === 'in_progress') return 'In Progress';
  if (status === 'completed') return 'Completed';
  if (status === 'scheduled') return 'Scheduled';
  if (status === 'final') return 'Final';
  return status;
}

function teamOutcome(teamScore, opponentScore) {
  if (teamScore === null || opponentScore === null) return '';
  if (teamScore > opponentScore) return 'team-win';
  if (teamScore < opponentScore) return 'team-loss';
  return '';
}

function formatGameDate(scheduledTime) {
  if (!scheduledTime) return '';
  const date = new Date(scheduledTime);
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export default function GamesView({ season, week, games, loading, error, onSelectGame, onBack }) {
  return (
    <div className="app app-wide">
      <button className="back-button" onClick={onBack}>Back to Weeks</button>
      <h2 className="section-title">
        {season.name} - {week.name}
        {' '}
        <span className="week-date-range">
          ({new Date(week.startDate + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
          {' - '}
          {new Date(week.endDate + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })})
        </span>
      </h2>

      {loading && <p className="loading">Loading games...</p>}
      {error && <p className="error">Error: {error}</p>}

      {!loading && !error && (
        <ul className="games-list">
          {games.map(game => {
            const showPrediction = game.status === 'scheduled' && game.preGameWinProbability;
            const awayColor = (TEAM_COLORS[game.awayTeam.id] || DEFAULT_TEAM_COLOR).primary;
            const homeColor = (TEAM_COLORS[game.homeTeam.id] || DEFAULT_TEAM_COLOR).primary;
            return (
              <li key={game.gameId} className="game-item" onClick={() => onSelectGame(game)}>
                <div className="game-teams">
                  <div className={`team ${teamOutcome(game.awayTeam.score, game.homeTeam.score)}`}>
                    <span className="team-name">{game.awayTeam.name}</span>
                    <span className="team-score">{game.awayTeam.score}</span>
                  </div>
                  <div className={`team ${teamOutcome(game.homeTeam.score, game.awayTeam.score)}`}>
                    <span className="team-name">{game.homeTeam.name}</span>
                    <span className="team-score">{game.homeTeam.score}</span>
                  </div>
                </div>
                {showPrediction && (
                  <div className="pregame-prob">
                    <span className="pregame-label">Predicted win probability</span>
                    <div className="pregame-bar">
                      <div className="pregame-fill" style={{ width: `${Math.round(game.preGameWinProbability.away * 100)}%`, background: awayColor }}>
                        {Math.round(game.preGameWinProbability.away * 100)}%
                      </div>
                      <div className="pregame-fill" style={{ width: `${Math.round(game.preGameWinProbability.home * 100)}%`, background: homeColor }}>
                        {Math.round(game.preGameWinProbability.home * 100)}%
                      </div>
                    </div>
                  </div>
                )}
                <div className="game-bottom">
                  <span className="game-date">{formatGameDate(game.scheduledTime)}</span>
                  <span className={`game-status status-${game.status}`}>
                    {statusLabel(game.status)}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
